/* ==================================================
  Section - Hero Carousel
================================================== */

const initHeroCarousel = () => {    
    const heroCarousel = document.querySelectorAll('.hero-slider')
    if(heroCarousel.length) {
        heroCarousel.forEach((item) => {
        const carousel = new Splide(item, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            pagination: true,
            arrows: false
        })      
        carousel.mount()
        })
    }
}
window.addEventListener('load', () => { initHeroCarousel() })